import { render, staticRenderFns } from "./ProcessesReports.vue?vue&type=template&id=9fd96eb8&"
import script from "./ProcessesReports.vue?vue&type=script&lang=js&"
export * from "./ProcessesReports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports